import { Component, OnInit } from '@angular/core';
import { saveAs as importedSaveAs } from "file-saver";
import {BasketItem} from '../../../components/basket/basket-item'
import {BasketService} from '../../../components/basket/basket.service'
import * as moment from 'moment';
import { ReportableService } from '../../../services/reportable.service';
import { Page } from '../../../models/paging/page';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { FilterService } from '../../../services/filter.service';
import { InspectionService } from '../../../services/inspection.service';

@Component({
  selector: 'app-rote-reports',
  templateUrl: './rote-reports.component.html',
  styleUrls: ['./rote-reports.component.scss']
})
export class ROTEReportsComponent implements OnInit {

  filter: any = {
    companyId: undefined,
    locationId: undefined,
    tabletUser_Id: undefined,
    categoryId: undefined,
    date_Range: 1,
    start_Date: moment().add(-1, 'months').toDate(),
    end_Date: moment().toDate(),
    job_No: '',
    serial_Num: '',
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  loading: boolean = false;
  disableCompany: boolean = false;
  disableLocation: boolean = false;
  page = new Page();
  rows = Array<any>();
  user;
  constructor(private reportableService: ReportableService, private basketService: BasketService, private authService: AuthService, private filterService: FilterService, public router: Router,
   public inspectionService: InspectionService) {
    this.user = this.authService.currentUser.value;
    this.page.pageNumber = 0;
    this.page.size = 9999999;

    // Check if any filters are present
    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.bindClientValues();
      this.loadTable()
    }

  }

  bindClientValues() {
    if (this.user.userProfileId != 1) {
      //user is a client, so throw them to the reports page
      if (this.user.companyId != undefined && this.user.companyId > 0) {
        this.filter.companyId = this.user.companyId;
        this.disableCompany = true;
      }

      if (this.user.locationId != undefined && this.user.locationId > 0) {
        this.filter.locationId = this.user.locationId;
        this.disableLocation = true;
        this.disableCompany = true;
      }
    }
  }
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.bindClientValues();
    this.loadTable();
  }

  rebind() {
    this.page.pageNumber = 0;
    this.loadTable();
  }
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    this.page.sortOrder = event.newValue;
    this.page.sortBy = event.column.prop;
    this.loadTable();
  }

  ngOnInit(): void {
    this.bindClientValues();
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.filterService.saveFilters(this.authService.currentUser.value.id, this.router.url, this.filter);
    this.inspectionService.getResults(this.page, this.filter.companyId, this.filter.locationId,
      this.filter.tabletUser_Id, this.filter.start_Date, this.filter.end_Date, this.filter.job_No,
      this.filter.serial_Num, this.filter.categoryId).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;
      ////console.log(this.rows);
      this.loading = false;

    }, (rejected) => {
      ////console.log(rejected);
      this.loading = false;
    });
   
  }

  downloadReport(id, type) {
    this.reportableService.getROTE(id).then((data) => {
      importedSaveAs(data, type + ".pdf");
    })
  }

  onCompanyChange(value) {
    this.filter.locationId = 0;
    if (value == undefined)
      this.filter.companyId = undefined;
    else
      this.filter.companyId = value.id;

  }
  onLocationChange(value) {

    if (value == undefined) {
      this.filter.locationId = undefined;
    }
    else {
      this.filter.locationId = value.id;
    }
  }
  onTechnicanChange(value) {
    if (value == undefined)
      this.filter.tabletUser_Id = undefined;
    else
      this.filter.tabletUser_Id = value.id;

  }
  onCategoryChange(value) {
    if (value == undefined)
      this.filter.categoryId = undefined;
    else
      this.filter.categoryId = value.id;
  }
  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }
  //addAllToBasket(){
  //  var items = this.rows;
  //  for(var i = 0;i< items.length; i++){
  //    var item = items[i];
  //    this.addToBasket(item);
    
  //  }
  //}

  //refreshRows() {
  //  var basketItems = this.basketService.getDatasource();
  //  var items = this.rows;
  //  for(var i = 0;i< items.length; i++){
  //    var item = items[i];
  //    var added = false;
  //    for(var b = 0;b< basketItems.length; b++){
  //      var basketItem = basketItems[b];
  //      if(item.id == basketItem.id)
  //      added = true;
  //    }
  //    item.added = added;
  //  }
     
  //}
}
